import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Dialog} from '../../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../../interfaces/dialog/dialog-params';
import {StatisticsService} from '../../../../../services/statistics/statistics.service';
import {LoaderService} from "../../../../../services/loader/loader.service";
import {ParisDatePipe} from '../../../../../pipes/date/paris-date.pipe';
import {PercentPipe} from "../../../../../pipes/percent/percent.pipe";
import {MoneyPipe} from "../../../../../pipes/money/money.pipe";
import {Paginator} from "../../../../../tools/pagination/paginator";
import {TableSorter} from "../../../../../tools/table-sorter/table-sorter";
import {TableSorterDirective} from "../../../../../directives/table-sorter/table-sorter.directive";
import {TableSorterHeaderDirective} from "../../../../../directives/table-sorter/table-sorter-header.directive";
import {PaginatorComponent} from "../../../../layout/paginator/paginator.component";

@Component({
  selector: 'app-transaction-list',
  imports: [
    ParisDatePipe,
    PercentPipe,
    MoneyPipe,
    TableSorterDirective,
    TableSorterHeaderDirective,
    PaginatorComponent
],
  templateUrl: './transaction-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './transaction-list.component.scss'
})
export class TransactionListComponent implements Dialog {
  conversions: any[] = [];

  paginator: Paginator = new Paginator(15);
  tableSorter: TableSorter = new TableSorter('conversionDate', 'desc');

  filters: any = {
    key: new Date().toISOString().split('T')[0],
    groupBy: 'date-day',
  };

  constructor(
    private loader: LoaderService,
    private statisticsService: StatisticsService
  ) {
  }

  onDialogInit(params: DialogParams): void {
    this.filters.key = params.data.key;
    this.filters.goalName = params.data.goalName;
    this.filters.goalTypeName = params.data.goalTypeName;
    this.filters.groupBy = params.data.filters.groupBy;
    this.filters.startDate = params.data.filters.startDate;
    this.filters.endDate = params.data.filters.endDate;

    if (params.data.filters.productId) {
      this.filters.productId = params.data.filters.productId;
    }

    if (params.data.filters.accountType) {
      this.filters.accountType = params.data.filters.accountType;
    }

    if (params.data.filters.transactionDate) {
      this.filters.transactionDate = params.data.filters.transactionDate;
    }

    if (params.data.filters.offerId) {
      this.filters.offerId = params.data.filters.offerId;
    }

    if (params.data.filters.partnerId) {
      this.filters.partnerId = params.data.filters.partnerId;
    }

    if (params.data.filters.landingPageId) {
      this.filters.landingPageId = params.data.filters.landingPageId;
    }

    if (params.data.filters.landingPageActiveSince) {
      this.filters.landingPageActiveSince = params.data.filters.landingPageActiveSince;
    }

    if (params.data.filters.country) {
      this.filters.country = params.data.filters.country;
    }

    if (params.data.filters.lang) {
      this.filters.lang = params.data.filters.lang;
    }

    if (params.data.filters.subid) {
      this.filters.subid = params.data.filters.subid;
    }

    if (params.data.filters.tc1) {
      this.filters.tc1 = params.data.filters.tc1;
    }

    if (params.data.filters.tc2) {
      this.filters.tc2 = params.data.filters.tc2;
    }

    if (params.data.filters.tc3) {
      this.filters.tc3 = params.data.filters.tc3;
    }

    if (params.data.filters.tc4) {
      this.filters.tc4 = params.data.filters.tc4;
    }

    if (params.data.filters.coreg) {
      this.filters.coreg = params.data.filters.coreg;
    }

    if (params.data.filters.cross) {
      this.filters.cross = params.data.filters.cross;
    }

    if (params.data.filters.paid !== undefined) {
      this.filters.paid = params.data.filters.paid;
    }

    this.refresh();
  }

  refresh(): void {
    this.loader.startLoading();
    const params: any = this.filters;

    this.statisticsService.getConversions(
      params,
      this.paginator,
      this.tableSorter
    ).subscribe((conversions) => {
      this.conversions = conversions;
      this.loader.stopLoading();
    });
  }

  getSourceTypology(conversion: any): string {
    if (conversion.coreg) {
      return 'P2';
    } else if (conversion.cross) {
      return 'XSELL'
    }

    return 'P1';
  }
}
